import React from 'react'
import Icon from './icon'

/**
 * @param onClick: function(event)
 * @param text: String
 * @param disabled: Boolean = false
 * @param minimal: Boolean = false
 * @param primary: Boolean = false; If set, the button has primary colors
 * @param iconName: String? : MaterialUI icons
 * @param type: String? : HTML property, e.g. "submit"
 */
class Button extends React.Component
{

    render()
    {
        const className = "dk-button "
            + (this.props.disabled ? "disabled " : "")
            + (this.props.minimal  ? "minimal " : "")
            + (this.props.primary  ? "primary " : "")
            + (!this.props.text && this.props.iconName ? "icon-button " : "")
            + (this.props.className || "")

        const icon = this.props.iconName ? (
            <Icon style={{ marginRight: this.props.text ? 3 : undefined }}>{ this.props.iconName }</Icon>
        ) : null

        return (
            <button 
                onClick={ this.props.disabled ? undefined : this.props.onClick }
                className={ className }
                style={ this.props.style }
                type={ this.props.type }
                disabled={ this.props.disabled }>
                { icon }
                { this.props.text }
            </button>
        )
    }

}

export { Button }
export default Button